<template>
  <div class="flex-column">
    <div class="d-flex">
      <div v-if="showViewToggle()" class="mobile-view-switch m-3">
        <Btn
          color="white"
          :icon="['fal', 'eye']"
          :border="true"
          :label="$t('general.changeView')"
          @click.native="setMobileView()"
        />
      </div>
    </div>

    <div
      v-if="pollInfoMessage"
      :class="aligmentCss"
      class="d-flex text-weight-semi-bold"
    >
      <div
        :style="gridTheme"
        :class="[pollInfoMessage.class, cssTheme]"
        class="legend-content text-size-14 flex-row"
      >
        <div class="mx-1">
          <font-awesome-icon class="mx-1" :icon="pollInfoMessage.icon" />
          {{ pollInfoMessage.text }}
        </div>
      </div>
    </div>

    <div
      v-if="isHiddenPoll"
      :class="aligmentCss"
      class="d-flex text-weight-semi-bold"
    >
      <div
        :style="gridTheme"
        class="legend-content text-size-14 flex-row"
        :class="cssTheme"
      >
        <div class="mx-1">
          <font-awesome-icon class="mx-1" :icon="['fas', 'info-circle']" />
          {{ msgHiddenPoll }}
        </div>
      </div>
    </div>

    <div
      v-if="showParticipateBtn"
      :class="aligmentParticipateButton"
      class="d-flex comments-and-todos align-items-center"
    >
      <div
        class="view-task-content align-items-center"
        :style="gridTheme"
        :class="cssParticipateButtonTheme"
      >
        <div class="participate-button text-center">
          <Btn :label="labelParticipateBtn" @click.native="onParticipate" />
        </div>
      </div>
    </div>

    <div :class="cssPage" class="pageView">
      <div :class="aligmentCss" class="d-flex align-items-start">
        <div ref="dataGrid" class="view-content grid-block" :class="cssTheme">
          <div class="grid-wrapper">
            <div ref="top"></div>
            <div class="aside">
              <div
                id="ParticipantBox"
                class="k-participant-list"
                :class="cssMode"
                :style="{ 'padding-bottom': participantPaddingBottom + 'px' }"
              >
                <div class="poll-info">
                  <div class="font-weight-600">
                    <span class="text-size-18"
                      >{{ $t('polls.participantResponseHeader') }}
                    </span>
                  </div>

                  <div v-if="isDateType" class="user-time-zone text-size-14">
                    <span class="text-size-12"
                      >{{ $t('general.timeZone') }}:
                    </span>
                    {{ Intl.DateTimeFormat().resolvedOptions().timeZone }}
                  </div>

                  <div
                    v-if="getInfoHTML"
                    class="user-time-zone text-size-14 mb-2"
                  >
                    {{ getInfoHTML }}
                    <span v-if="0 && isOwner" class="text-size-20">
                      <font-awesome-icon
                        v-if="poll.options.hiddenPoll"
                        :icon="['fal', 'eye-slash']"
                      />
                    </span>
                  </div>
                  <!-- New form input -->

                  <transition
                    v-on:after-enter="afterEnter"
                    v-on:after-leave="afterEnter"
                    name="fadeHeight2"
                  >
                    <div
                      v-if="submittingParticipant"
                      :style="submitRowHeight"
                      class="submit-row test d-flex rounded-left-corners"
                    >
                      <div
                        class="h-100 d-col text-size-16 mt-1 justify-content-between"
                      >
                        <div>
                          <div
                            class="m-b-2 text-size-14 text-weight-semi-bold d-flex"
                          >
                            <div>
                              {{ $t('submit.editResponse') }}
                            </div>
                          </div>
                          <div
                            class="text-size-12 mt-1"
                            v-html="submittingParticipantEmail"
                          ></div>
                          <div class="text-size-16 text-weight-semi-bold">
                            <div class="d-flex mt-2">
                              <div>
                                {{ submittingParticipant.name }}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div v-if="!submitting" class="row my-1">
                          <BtnLink
                            @click.native="cancelResponse"
                            :label="$t('general.cancel')"
                          />
                          <Btn
                            @click.native="submitResponse"
                            :label="$t('options.submitResponseMobile')"
                          />
                        </div>
                        <div
                          v-else
                          class="row my-1 response-success justify-content-center m-2 mx-5 text-size-14 p-1"
                        >
                          {{ $t('options.partialAnswerSubmitted2') }}
                        </div>
                      </div>
                    </div>
                  </transition>
                </div>

                <div :class="cssMode" class="k-participant-header mt-2 mb-1">
                  <div style="height: 38px;" class="header-row">
                    <div
                      class="d-flex grid-section-title text-font-18 text-weight-semi-bold"
                      :class="cssMode"
                    >
                      {{ participantsCount }} {{ $t('polls.participants') }}
                      <span
                        v-if="isOwner"
                        v-on:click="enterNewParticipant()"
                        class="text-primary ml-2"
                      >
                        <font-awesome-icon :icon="['fas', 'plus-circle']" />
                      </span>
                    </div>
                    <RenderSortingIcons v-if="showSortIcons" />
                  </div>
                </div>
                <!-- END participants header-->

                <div :class="cssMode" class="k-participants">
                  <div
                    v-for="participant in participantList(
                      submittingParticipant
                    )"
                    :key="participant.id"
                    class="k-participant participant-border"
                    :class="[isCurrentUserParent(participant), cssMode]"
                    :style="fixedHeight"
                  >
                    <div>
                      <div
                        class="k-participant-sub-details"
                        style="display: flex; width: 100%;"
                      >
                        <div :class="textColor" class="k-participant-icons">
                          <div class="d-flex">
                            <font-awesome-icon
                              class="mb-1 user-circle align-slef-end"
                              size="xs"
                              color=""
                              v-if="participant.user_id"
                              :icon="['fas', 'user-circle']"
                            />
                          </div>
                          <div v-if="isInvited(participant)" class="d-flex">
                            <font-awesome-icon
                              class="user-circle"
                              size="xs"
                              color=""
                              :icon="['fal', 'envelope-open']"
                              v-if="isInvitationVisited(participant)"
                            />
                            <font-awesome-icon
                              v-else
                              class="user-circle"
                              size="xs"
                              color=""
                              :icon="['fal', 'envelope']"
                            />
                          </div>
                        </div>
                        <div
                          class="k-participant-details align-items-start"
                          :class="getParticipantClasses(participant)"
                        >
                          <div
                            v-if="isEditable(participant, poll)"
                            class="k-grid-participant-name text-standard mt-1 pointer"
                          >
                            <span @click="startEditParticipant(participant)">
                              {{
                                participant.name != ''
                                  ? participant.name
                                  : $t('general.myself')
                              }}
                            </span>
                            <span
                            @click="startEditParticipant(participant)"
                            class="d-inline p-1">
                              <font-awesome-icon
                                size="xs"
                                color=""
                                :icon="['fas', 'pencil']"
                              />
                            </span>
                            <span
                              @click="removeParticipant(participant)"
                              class="d-inline p-1"
                            >
                              <font-awesome-icon
                                size="xs"
                                color=""
                                :icon="['fal', 'trash-alt']"
                              />
                            </span>
                          </div>
                          <div
                            v-else
                            class="k-grid-participant-name text-standard mt-1"
                          >
                            {{ participant.name }}
                          </div>

                          <div
                            class="k-participant-email text-very-small text-weight-light"
                            v-if="getParticipantEmail(participant)"
                          >
                            {{ getParticipantEmail(participant) }}
                          </div>
                          <div
                            v-if="
                              !hideWhenNewPoll && isAnswerEditable(participant)
                            "
                            class="edit-rsponses text-size-14 justify-content-start"
                          >
                            <BtnLink
                              v-if="isResponseEditable(participant)"
                              class="btn-edit-response p-0"
                              @click.native="editResponse(participant)"
                              :label="$t('options.editResponse')"
                            />
                          </div>
                        </div>
                        <div
                          v-if="
                            0 &&
                            !hideWhenNewPoll &&
                            isAnswerEditable(participant)
                          "
                          class="k-participant-end text-size-14 justify-content-center"
                        >
                          <BtnLink
                            v-if="isResponseEditable(participant)"
                            @click.native="editResponse(participant)"
                            :label="$t('options.editResponse')"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- END v-for participants -->

                  <div
                    v-for="invitation in openInvitations"
                    :key="invitation.id"
                    :class="cssMode"
                    class="k-participant"
                  >
                    <div class="k-participant-icons">
                      <div class="k-participant-icon">
                        <font-awesome-icon
                          class="pb-0 user-circle"
                          size="xs"
                          color=""
                          :icon="['fal', 'envelope-open']"
                          v-if="invitation.visited"
                        />
                        <font-awesome-icon
                          class="pb-0 close-envelope user-circle"
                          size="xs"
                          :icon="['fal', 'envelope']"
                          v-else
                        />
                      </div>
                      <div class="k-participant-icon">
                        <i
                          class="fas fa-cog fa-1x k-p-icon"
                          v-if="invitation.showCogIcon"
                        ></i>
                      </div>
                    </div>
                    <div class="k-participant-details">
                      <div
                        class="k-participant-end text-standard text-weight-regular align-self-start"
                      >
                        {{ invitation.email }}
                      </div>
                    </div>
                  </div>
                  <!-- END v-for invitations -->
                </div>
              </div>
            </div>
            <!-- END aside participants -->


            <!-- Start rendering chices  -->

            <div
              class="scroll-wrapper"
              :style="{ 'max-width': scrollWrapperMaxWidth + 'px' }"
            >
              <div id="ChoicesBox" class="choices-wrapper">
                <div
                  class="paging"
                  v-if="pagingVisible"
                  :style="{ left: scrollLeft + 'px' }"
                >
                  <font-awesome-icon
                    style="float: left; cursor: pointer;"
                    v-if="leftPagingIconVisible"
                    @click="doScrollLeft"
                    :icon="['fas', 'arrow-alt-left']"
                  />

                  <font-awesome-icon
                    style="float: right; cursor: pointer;"
                    v-if="rightPagingIconVisible"
                    @click="doScrollRight"
                    :icon="['fas', 'arrow-alt-right']"
                  />
                </div>
                <!-- END paging icons -->
                <RenderChoices
                  :submittingParticipant="submittingParticipant"
                  @editedChoice="onEditedChoice"
                  @afterLeave="afterLeave"
                  @showInfo="onShowInfo"
                  :choices="choices"
                  :dlgChoiceDialog="dlgChoiceDialog"
                  :openInvitations="openInvitations"
                />
                <!-- END k-choices -->
              </div>
              <!-- END ChoicesBox -->
            </div>

            <!-- END scroll-wrapper -->
          </div>
          <render-hidden-mode-participant
            v-if="0 && isHiddenParticipantMode"
            :adminName="poll.user_name"
            :type="polltype(poll.type)"
          />
          <!-- END grid-wrapper -->
        </div>
      </div>
      <!-- END view-content -->

      <div
        v-if="showTasks"
        :class="aligmentCssComments"
        class="d-flex comments-and-todos align-items-start"
      >
        <div
          ref="taskGrid"
          class="view-task-content"
          :style="gridTheme"
          :class="cssCommentsTheme"
        >
          <div class="grid-wrapper">
            <div class="comments">
              <div
                class="comments-headline grid-section-title mb-2"
                :class="cssMode"
              >
                <div class="d-flex justify-content-between align-items-center">
                  <div>{{ $t('tasks.headline') }} ({{ pollTasks.length }})</div>
                  <div
                    v-if="isRegularOwner"
                    class="text-size-14 align-self-center mt-1 text-weight-regular"
                  >
                    {{ freeTaskCout }} {{ $t('tasks.free') }}
                  </div>
                </div>
              </div>

              <Tasks :tasksList="pollTasks"> </Tasks>
            </div>
          </div>
        </div>
      </div>
      <!-- END tasks -->

      <div
        :class="aligmentCssComments"
        class="d-flex comments-and-todos align-items-start"
      >
        <div class="d-flex align-items-start">
          <div
            v-if="showComments"
            ref="commentGrid"
            class="view-content"
            :style="gridTheme"
            :class="cssCommentsTheme"
          >
            <div class="grid-wrapper">
              <div class="comments">
                <div
                  v-if="commentsHeadline"
                  class="comments-headline grid-section-title"
                  :class="cssMode"
                >
                  {{ commentsHeadline }}
                </div>

                <Comments
                  :commentsList="pollComments"
                  v-on:add="addComment"
                  v-on:delete="deleteComment"
                  :canPostComment="canPostComment"
                  :canSeeList="canSeeList"
                  :disableAddCommentButton="submittingParticipant != null"
                ></Comments>
              </div>
            </div>
          </div>
        </div>
        <!-- END comment -->
      </div>
      <ModalConfirm
        v-if="showConfirmDelete"
        :msg="titleConfirmDelete"
        @confirm="deleteSelectedParticipant"
        :loading="deleting"
        @cancel="showConfirmDelete = false"
      />
      <ModalParticipant
        ref="newParticipantModal"
        :user="user"
        :invitation="invitation"
        :edit-mode="modalEditMode"
        :edit-participant="editParticipant"
        :is-new-user="isClickToAddNewParticiapnt"
        @save="onSaveModal"
        @cancel="stopEditParticipant"
        @removed="submittingParticipantRemoved"
      >
      </ModalParticipant>
      <ModalChoiceDialog
        ref="dlgChoiceDialog"
        :editedChoice="editedChoice"
        @selectChoice="onSelectChoice"
      />

      <ModalFeedbackDialog ref="dlgFeedbackDialog"> </ModalFeedbackDialog>

      <ModalThanksDialog
        ref="dlgThanksDialog"
        :submittingParticipant="submittingParticipant"
      >
      </ModalThanksDialog>

      <ModalConfirm
        v-show="showConfirm && submittingParticipant"
        :msg="$t('options.dlgConfirmTitle')"
        :loading="false"
        :showNoButton="false"
        okLabel="OK"
        :width="450"
        @confirm="onCompleteOK"
        customClass="text-weight-semi-bold"
      >
        {{ $t('options.dlgConfirmBody') }}
      </ModalConfirm>

      <!-- multi votes maximum limit exceed error -->
      <ModalDialog
        ref="dlgMaximumVotesExceed"
        :title="$t('general.notAllowed')"
        :labelOk="$t('general.ok')"
        labelCancel=""
        :showCancelIcon="false"
        :displayCancelButton="false"
        @ok="reloadBrowser()"
      >
        <!-- replace true with isPaymentComplete in displayOkButton -->
        <div class="text-small" v-html="choiceUpdateErrorHTML"></div>
      </ModalDialog>

      <ModalParticipantInfoDialog
        ref="dlgPaymentDialog"
        :participants="userData"
        :isOwner="isOwner"
      >
      </ModalParticipantInfoDialog>

      <ModalSameEmailDialog
        ref="dlgParticipantsWithSameEmail"
        :participantsWithSameEmail="existingParticipants"
        :participantData="participantData"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import ModalParticipant from '@/components/UI/ModalParticipant';

import ModalChoiceDialog from './ModalChoiceDialog';

import Comments from '@/components/Rendering/Comments.vue';
import Tasks from '@/components/Rendering/Tasks.vue';
import RenderChoices from './RenderChoices.vue';
import RenderSortingIcons from './RenderSortingIcons.vue';
import RenderHiddenModeParticipant from './RenderHiddenModeParticipant';
// import RenderHelpContent from './RenderHelpContent';

import { renderMixin } from '../mixins/RenderMixins';
import { deviceMixin } from '../mixins/DeviceMixins';
import { gridMixin } from '../mixins/GridMixins';
import { themeMixin } from '../mixins/ThemeMixins';
import { pollMixin } from '../mixins/PollMixins.js';

import sortParticipants from '@/shared/sortParticipants';
import { modalParticipantMixins } from '../mixins/ModalParticipantMixins';
import { constants } from '@/shared/constant';

import ModalSameEmailDialog from './ModalSameEmailDialog.vue';

export default {
  name: 'RendererData',
  mixins: [
    renderMixin,
    deviceMixin,
    gridMixin,
    modalParticipantMixins,
    themeMixin,
    pollMixin,
  ],
  components: {
    ModalParticipant,
    Comments,
    Tasks,
    RenderChoices,
    RenderSortingIcons,
    RenderHiddenModeParticipant,
    ModalChoiceDialog,
    ModalSameEmailDialog,
  },

  data() {
    return {
      userData: [],
      // data for scrolling, resize, participants
      showConfirm: false,
      showConfirmDelete: false,
      editMode: false,
      submittingParticipant: null,
      submitting: false,
      // participantBackup: null,
      dlgChoiceDialog: null,
      dlgFeedbackDialog: null,
      dlgThanksDialog: null,
      participantForRemoval: null,

      editedChoice: {
        posX: 50,
        posY: 50,
      },

      participantPaddingBottom: 0,
      scrollWidth: 0,
      clientWidth: 0,
      offsetWidth: 0,
      choiceColumnWidth: 0,
      scrollWrapperMaxWidth: 1000,
      pagingVisible: false,
      scrollLeft: 0,
      leftPagingIconVisible: false,
      rightPagingIconVisible: true,
      // end scrolling data
      participantData: null,
      editParticipant: null,
      currentUserParticipantIds: [],
      modalEditMode: false,
      isClickToAddNewParticiapnt: false,
      notificationMessage: '',
      currentUserCustomClass: '',
      timeBeforeMount: null,
      timeMounted: null,
      choiceUpdateErrorHTML: '',
      deleting: false,
    };
  },

  methods: {
    ...mapActions(['addComment', 'deleteComment']),

    // onSelectChoice(value) {
    //   this.selectChoice(value, this.editedChoice);
    // },


    deleteSelectedParticipant() {
      this.deleting = true;
      this.$store
        .dispatch('removeParticipant', this.participantForRemoval)
        .then(() => {
          this.deleting = false;
          this.showConfirmDelete = false;
          this.closeModal();
          this.$emit('removed');
        });
    },
    removeParticipant(participant) {
      this.participantForRemoval = participant;
      console.info('try to remove participant:', participant.name);
      this.showConfirmDelete = true;
    },

    onShowInfo(choiceId) {
      console.info('onShowInfo:', choiceId);
      this.userData = this.getAllParticipantOfChoice(choiceId);
      this.$nextTick(() => {
        this.$refs.dlgPaymentDialog.openModal();
      });
    },

    afterEnter() {
      this.$nextTick(() => {
        this.$nextTick(() => {
          this.setScrollbarData();
        });
      });
    },

    afterLeave() {
      this.$nextTick(() => {
        this.$nextTick(() => {
          this.setScrollbarData();
        });
      });
    },

    submittingParticipantRemoved() {
      this.submittingParticipant = null;
      console.log('submittingParticipantRemoved');
    },

    editResponse(participant) {
      if (this.submittingParticipant) return;
      this.submittingParticipant = participant;
      const participantBackup = JSON.parse(JSON.stringify(participant));
      this.$store.commit('setParticipantBackup', participantBackup);
      console.log('editResponse for:', this.submittingParticipant);
      this.$nextTick(() => {
        this.goto('top');
      });
    },

    delay(milliseconds) {
      return new Promise((resolve) => {
        setTimeout(resolve, milliseconds);
      });
    },

    // ToDo - reuse the desctop call also n mobile
    async submitResponse() {
      if (
        !this.poll.options.limitedVotesPerChoice &&
        this.isAnswerEmpty(this.submittingParticipant)
      ) {
        this.showConfirm = true;
        return;
      }
      if (this.isAnswerEmpty(this.participantBackup)) {
        // show Thanks Dialog
        this.dlgThanksDialog.openModal(null);
      }
      //this.dlgThanksDialog.openModal(null);
      console.info(
        'Submit Respone for participant:',
        this.submittingParticipant
      );
      this.completeSubmitResponse(this.submittingParticipant, true);
    },

    onCompleteOK() {
      this.showConfirm = false;
    },

    async completeSubmitResponse(participant, isSubmitMode) {
      const choices = [];

      if (isSubmitMode) {
        this.submitting = true;
      }

      for (var p of participant.preference_list) {
        // if not selected any answer then select default NO
        if (
          this.poll.options.setDefaultAsNoForNotAnswered == true &&
          p.value == -1
        ) {
          p.value = 0;
        }
        console.info('complete submission for preference:', p);
        const limit = this.poll.choices.find((c) => c.id == p.choice_id).limit;
        choices.push({
          choice_id: p.choice_id,
          answers: p.answers,
          value: p.value,
          limit: limit,
        });
      }

      const data = {
        choices: choices,
        oneChoicePerParticipant: this.poll.options.oneChoicePerParticipant,
        participantId: participant.id,
      };
      console.info('submit Response for:', participant, data);

      this.$store
        .dispatch('updateChoicesV2', data)
        .then(async (response) => {
          console.log(response);
          if (response.data.error) {
            if (response.data.oneOptionError == true) {
              this.choiceUpdateErrorHTML = this.$t(response.data.error);
            } else {
              this.choiceUpdateErrorHTML = this.createLimitErrorString(
                response
              );
            }
            this.$refs.dlgMaximumVotesExceed.openModal();
          } else {
            this.$store.commit('updateParticipant', participant);
          }

          if (isSubmitMode) {
            await this.delay(2000);
          }

          this.$store.commit('setParticipantBackup', null);
          this.submittingParticipant = null;
          this.submitting = false;
        })
        .catch((error) => {
          console.log('completeSubmitResponse ==> ', error);
        });
    },

    cancelResponse() {
      console.log('cancelResponse');
      const fronEndOnly = true;
      if (fronEndOnly) {
        this.$store.commit('updateParticipant', this.participantBackup);
        this.$store.commit('setParticipantBackup', null);
        this.submittingParticipant = null;
        this.setScrollbarData();
      } else {
        this.completeSubmitResponse(this.participantBackup, false);
      }
    },

    setMobileView() {
      console.log('Set mobile view');
      this.$store.commit('setMobileView', true);
    },

    onEditedChoice(data) {
      this.editedChoice = data;
      //console.log('onEditedChoice', this.editedChoice);
    },

    choiceText(choice) {
      var element = document.getElementsByClassName('class-' + choice.id);
      if (!element) return choice.text;

      element.h;
      var $p = $('#fos p');
      var divh = $('#fos').height();
      while ($p.outerHeight() > divh) {
        $p.text(function (index, text) {
          return text.replace(/\W*\s(\S)*$/, '...');
        });
      }
    },

    isInvitationVisited(participant) {
      if (!participant.invitation) return false;
      return participant.invitation.visited;
    },

    // START new participant / edit participant

    // START component helper functions
    getAnswerForChoice(participant, choice) {
      var choiceId = choice.id;
      if (participant && choiceId && participant.preference_list) {
        let preferenceForChoice = participant.preference_list.find(
          (preference) => preference.choice_id === choiceId
        );
        if (preferenceForChoice) {
          return preferenceForChoice.value;
        }
      }
      return -1;
    },

    getParticipantEmail(participant) {
      if (!this.isEmailVisible(participant)) return null;

      if (participant.invitation != null) {
        return participant.invitation.email;
      }
      if (participant.user != null) {
        return participant.user.email;
      }
      if (this.poll.user.id === participant.user_id) {
        return this.poll.user.email;
      }
      return null;
    },

    getParticipantClasses(participant) {
      let classes = ''; /*this.getEditableClass(participant);*/
      if (participant.isCurrentUser || participant.isCurrentUserParticipant) {
        classes += ' is-current-user';
      }
      return classes;
    },

    getEditableClass(participant) {
      let classes = '';
      if (this.isEditable(participant)) {
        classes = ' editable';
      }
      return classes;
    },
    isCurrentUserParent(participant) {
      if (participant.isCurrentUser || participant.isCurrentUserParticipant) {
        return ' is-current-user-parent border-bottom-0';
      }
      return '';
    },
    getClassBasedOnChoice(participant = null) {
      if (participant == null) {
        for (let i = 0; i < this.poll.participants.length; i++) {
          if (this.poll.participants[i].isCurrentUser == true) {
            participant = this.poll.participants[i];
            break;
          }
        }
      }
      this.compareChoices(participant);
    },

    compareChoices(participant) {
      this.notificationMessage = '';
      this.currentUserCustomClass = 'current-user-notification';
      if (Array.isArray(participant)) {
        let found = false;
        for (let i = 0; i < participant.length; i++) {
          if (participant[i].isCurrentUser == true) {
            participant = participant[i];
            found = true;
            break;
          }
        }
        if (found == false) {
          participant = null;
        }
      }
      if (participant) {
        if (participant.preference_list.length == 0) {
          return '';
        }
        let choicesCount = 0;
        for (let i = 0; i < participant.preference_list.length; i++) {
          if (participant.preference_list[i].value != -1) {
            choicesCount += 1;
          }
        }

        if (choicesCount == 0) {
          this.notificationMessage = 'options.noAnswerSubmitted';
          this.currentUserCustomClass += ' notification-red-bar';
        } else if (choicesCount < participant.preference_list.length) {
          this.notificationMessage = 'options.partialAnswerSubmitted';
          this.currentUserCustomClass += ' notification-yellow-bar';
        } else if (choicesCount == participant.preference_list.length) {
          this.notificationMessage = 'options.allAnswerSubmitted';
          this.currentUserCustomClass += ' notification-green-bar';
        }
      }
    },

    // START component helper functions

    // START scrolling, resize, participants
    setScrollbarData(resetScrollLeft = true) {
      // console.info('setScrollbarData');
      const choicesBox = document.getElementById('ChoicesBox');
      const aside = document.getElementsByClassName('aside')[0];

      let heightDiff = 0;
      if (choicesBox) {
        // if scrollbar is on the right, it will not dissapear on resize
        // so set scrollLeft to 0 (scrollbar to the left side)
        // but only on resize not in Vue updated event hook
        if (resetScrollLeft) {
          choicesBox.scrollLeft = 0;
          //console.log('scrollLeft set to 0');
        }

        choicesBox.removeEventListener('scroll', this.getScrollPos);
        choicesBox.addEventListener('scroll', this.getScrollPos);

        // there is a difference between offsetHeight and clientHeight if a scrollbar is visible
        // difference equals the hight of scrollbar
        heightDiff = choicesBox.offsetHeight - choicesBox.clientHeight;
        console.info('setScrollbarData heightDiff:', heightDiff);

        // client/offsetHeight = visible part of choices box
        this.clientWidth = choicesBox.clientWidth;
        this.offsetWidth = choicesBox.offsetWidth;

        // scrollWidth = total width of choices box
        this.scrollWidth = choicesBox.scrollWidth;
      } else {
        console.error('no choicesBox!!');
      }
      if (aside) {
        // aside.getBoundingClientRect().x = x pos on page of aside-div (= 2vw = 2% of window width)
        // multiply by 2 to have same margin on the right
        // aside.clientWidth = width of participant column
        // +20 due to padding-right: 20px of grid-wrapper

        if (this.isGridCentered) {
          this.scrollWrapperMaxWidth =
            window.innerWidth - (aside.clientWidth + 20);
        } else {
          this.scrollWrapperMaxWidth =
            window.innerWidth -
            (aside.getBoundingClientRect().x * 2 + aside.clientWidth + 0);
        }
      } else {
        this.scrollWrapperMaxWidth = window.innerWidth * 0.7;
      }

      // console.log(
      //   'scrollWrapperMaxWidth: ',
      //   this.scrollWrapperMaxWidth,
      //   window.innerWidth,
      //   aside.clientWidth,
      //   aside.getBoundingClientRect().x
      // );

      let choiceDetails = document.getElementsByClassName(
        'k-choice-details'
      )[0];
      if (choiceDetails) {
        this.choiceColumnWidth = choiceDetails.clientWidth;
      }
      // this.choiceColumnWidth = document.getElementsByClassName(
      //   'k-choice-details'
      // )[0].clientWidth;

      // add padding-bottom to participant with the same value as hight of scrollbar (or 0)
      this.participantPaddingBottom = heightDiff;
      //console.log('setScrollbarData: ', heightDiff);

      // add paging icon div, if more than half of a choice column is not visible
      this.pagingVisible =
        this.clientWidth < this.scrollWidth - this.choiceColumnWidth / 2;
      this.updateRowMode();
    },

    // get the position of the choices scrollbar and set visibility of left/right paging icon accordingly
    getScrollPos() {
      const choicesBox = document.getElementById('ChoicesBox');
      this.scrollLeft = choicesBox.scrollLeft;
      this.leftPagingIconVisible = this.scrollLeft > this.choiceColumnWidth / 2;
      this.rightPagingIconVisible =
        this.scrollWidth - this.clientWidth - this.scrollLeft >
        this.choiceColumnWidth / 2;
    },

    // scroll left the width of a choice column
    doScrollLeft() {
      const choicesBox = document.getElementById('ChoicesBox');
      choicesBox.scrollLeft < this.choiceColumnWidth
        ? (choicesBox.scrollLeft = 0)
        : (choicesBox.scrollLeft -= this.choiceColumnWidth);
      this.getScrollPos();
    },

    // scroll right the width of a choice column
    doScrollRight() {
      const choicesBox = document.getElementById('ChoicesBox');
      this.scrollWidth - this.clientWidth - this.scrollLeft <
      this.choiceColumnWidth
        ? (choicesBox.scrollLeft = this.scrollWidth - this.clientWidth)
        : (choicesBox.scrollLeft += this.choiceColumnWidth);
      this.getScrollPos();
    },
    // END scrolling, resize, participants

    showViewToggle() {
      const clientWidth =
        window.innerWidth > 0 ? window.innerWidth : screen.width;
      return clientWidth < constants.mobileBreakpoint;
    },
  },

  computed: {
    ...mapGetters({
      isOwner: 'isOwner',
      isPremium: 'isPremium',
      userName: 'userName',
      isAuthenticated: 'isAuthenticated',
      user: 'user',
      userId: 'userId',
      pollComments: 'pollComments',
      pollTasks: 'pollTasks',
      isPublicLink: 'isPublicLink',
      isAdminLink: 'isAdminLink',
      isDarkMode: 'isDarkMode',
      isPollEditable: 'isPollEditable',
      hideWhenNewPoll: 'getPollStatus',
    }),


    titleConfirmDelete(){
      let title = this.$t('participantModal.confirmDelete');
      const name = this.participantForRemoval.name;
      title = title.replace('%s', name);
      return title;
    },



    submittingParticipantEmail() {
      if (this.submittingParticipant.user) {
        return this.submittingParticipant.user.email;
      }
      return '&nbsp;';
    },

    getInfoHTML() {
      console.log(
        'Options:',
        this.poll.options.hiddenPoll,
        this.poll.options.limitedVotesPerChoice
      );
      if (
        this.poll.options.hiddenPoll ||
        this.poll.options.limitedVotesPerChoice
      ) {
        let html = ' ';
        // "<span class='text-size-12'>" +
        // this.$t('options.options') +
        // ': </span>';
        let shownOption = 0;
        // if (this.poll.options.hiddenPoll) {
        //   html +=  this.$t('options.hiddenPoll');
        //   shownOption = 1;
        // }
        if (this.poll.options.limitedVotesPerChoice) {
          console.log(shownOption);

          let optionText = this.$t('options.limitVotesPerChoice').replace(
            '%d',
            this.poll.options.votesLimit
          );
          if (shownOption > 0) {
            optionText = '; ' + optionText;
          }
          let optionHtml = optionText;
          console.log(shownOption, optionHtml);
          html = html + optionHtml;
        }
        if (html == ' ') {
          html = null;
        }
        return html;
      }
      return null;
    },

    choices() {
      return this.poll.choices;
    },

    participantsCount() {
      if (this.isHiddenParticipantMode) return '';
      return this.poll.participants.length;
    },

    ...mapState({
      curInvitation: (state) => state.curInvitation,
      poll: (state) => state.poll.poll,

      ownerId: (state) => state.poll.poll.user.id,
      keyUserId: (state) => state.keyUserId,
    }),

    invitations() {
      return this.poll.invitations;
    },

    mayBeAnswersEnabled() {
      return this.poll.options.mayBeAnswers;
    },
  },

  beforeCreate() {
    console.info('(RenderData) beforeCreate:', Date.now());
  },

  beforeMount() {
    console.info('(RenderData) beforeMount:', Date.now());
    this.timeBeforeMount = Date.now();
  },

  async mounted() {
    const startTime = new Date();
    //console.info('(RenderData) mounting started:', Date.now());
    this.dlgChoiceDialog = this.$refs.dlgChoiceDialog;
    this.dlgFeedbackDialog = this.$refs.dlgFeedbackDialog;
    this.dlgThanksDialog = this.$refs.dlgThanksDialog;
    console.log(
      '(RenderData) cur invitation:',
      this.curInvitation,
      this.isOwner
    );

    let participants = this.identifyCurrentUser(this.poll.participants);
    console.info('(RenderData) participants:', participants);

    // make sure that the current user is on the top of the list
    sortParticipants(participants, this.userId, this.sortAlphabetical);
    this.$store.commit('updateParticipants', participants);

    this.setScrollbarData(false);
    this.getClassBasedOnChoice(participants);

    this.currentParticipant = this.getCurrentParticipant();

    const mountTime = new Date();
    const timeDiff = (mountTime - startTime) / 1000; //in s
    console.info('(RenderData) mounting completed in:', timeDiff);

    this.timeMounted = Date.now();
    const timeDiff2 = (this.timeMounted - this.timeBeforeMount) / 1000; //in s
    console.info('(RenderData) total mounting completed in:', timeDiff2);

    if (!this.isOwner && this.currentParticipant) {
      const participant = this.currentParticipant;
      if (!this.isAnswerEmpty(participant)) return;
      if (!this.isAnswerEditable(participant)) return;
      this.submittingParticipant = participant;
      const participantBackup = JSON.parse(JSON.stringify(participant));
      this.$store.commit('setParticipantBackup', participantBackup);
      return;
    }
    const doEnterNewParticipant = this.isNewParticipantRequired();
    if (doEnterNewParticipant) {
      this.enterNewParticipant(true);
    }
  },
  updated() {
    this.setScrollbarData(false);
  },
  watch: {
    'poll.participants': {
      deep: true,
      handler() {
        this.getClassBasedOnChoice();
        this.currentParticipant = this.getCurrentParticipant();
      },
    },
  },
  // set resize event handler on created
  created() {
    console.info('(RenderData) created:', Date.now());
    window.addEventListener('resize', this.setScrollbarData);
    window.addEventListener('resize', this.updateRowMode);
  },

  // remove resize event handler on destroyed
  destroyed() {
    window.removeEventListener('resize', this.setScrollbarData);
    window.removeEventListener('resize', this.updateRowMode);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '@/styles/style';
@import '@/styles/submit-form';
$bg-color: rgba(255, 255, 255, 0.3);

.editable {
  cursor: pointer;
}

.button-round {
  border-radius: 50%;
}

.break {
  flex-basis: 100%;
  height: 0;
}

.choices-wrapper {
  overflow: auto;
  display: flex;
  flex-direction: column;
  // uncomment the next two lines if scrolbars should be hidden in general
  // -ms-overflow-style: none;  /* Internet Explorer 10+ */
  // scrollbar-width: none;  /* Firefox */

  & .paging {
    width: 100%;
    color: red;
    position: relative;
  }
}
/*.choices-wrapper .paging {
  width: 100%;
  color: red;
  position: relative;
}*/
.choices-wrapper::-webkit-scrollbar {
  /* WebKit */
  // uncomment the next two lines if scrolbars should be hidden in general
  // width: 0;
  // height: 0;
}

.dayMonth {
}

.timeRange {
  white-space: nowrap;
}

// .choice-text-survey {
//   min-width: 120px;
//   max-width: 240px;
//   height: 100%;
//   overflow: hidden;
//   overflow-wrap: break-word;
//   word-break: break-word;
//   hyphens: auto;
//   -moz-hyphens: auto;
//   display: flex;
//   flex-grow: 1;
// }

.k-participant-choices {
  display: flex;
  flex-direction: column;
  justify-content: stretch;
}

.k-padding {
  padding: 0.3em;
}

.k-p-icon {
  padding-right: 10px;
}

/* .info-box {
  position: absolute;
  bottom: 200px;
} */

.is-current-user {
  font-weight: 800;
}
.k-no-answer {
  overflow-wrap: break-word;
  text-align: center;
}

.k-grid-participant-name {
  white-space: nowrap;
  max-width: 250px;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.k-participant-icon {
  display: contents;
}

// .user-circle {
//   color: $light-grey;
// }

.close-envelope {
  margin-left: 0.18rem !important;
}

.blur-information {
  -webkit-filter: blur(10px);
  -moz-filter: blur(10px);
  -o-filter: blur(10px);
  -ms-filter: blur(10px);
  filter: blur(10px);
}
.is-current-user-parent {
  border-top: 2px solid;
  border-right: unset;
  border-left: unset;
  display: block !important;
}
.k-participant-sub-details {
  display: flex;
  height: 100%;
}
.current-user-notification {
  font-size: $very-small;
  font-weight: $medium-weight;
  text-align: center;
  margin: 2px;
  border-radius: 3px;
}
.notification-red-bar {
  //background-color: $primary;
  color: $primary;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.notification-yellow-bar {
  //background-color: $user-bubble;
  color: $checked-color;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.notification-green-bar {
  //background-color: $secondary;
  color: $checked-color;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.comments-and-todos {
  flex-wrap: wrap;
}
.border-bottom-0 {
  border-bottom: unset !important;
}
.is-current-user-parent.border-bottom-0 {
  border-bottom: 3px solid !important;
}
.pd-6 {
  padding: 6px;
}

.poll-info {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.d-col {
  display: flex;
  width: 100%;
  flex-direction: column;
  padding: 5px;
}

.response-success {
  background-color: $primary-dark;
  color: $white;
}

.k-participant-header {
  min-height: 39px; // you have to also fix .yes-counts
  display: block;
}

.k-participant-header {
  padding-bottom: 3px;

  & .header-row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    & .header-item {
      padding: 0px;
      padding-right: 8px;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      justify-content: end;
    }

    & .add-participant {
      display: flex;
      flex-direction: column;

      & .button-row {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
      }
    }
  }
}

.k-participant-header.light-mode {
  border-bottom: 0px solid $grid-border;
}

.k-participant-header.dark-mode {
  border-bottom: 0px solid white;
}

.participant-border {
  border-bottom: 1px solid $grid-border;
}

.participant-border.dark-mode {
  border-bottom: 1px solid white;
}

.btn-sm {
  padding-bottom: 2px;
  padding-top: 2px;
}

.k-participants {
  display: flex;
  flex-direction: column;
  border-top: 1px solid $grid-border;
}

.k-participants.dark-mode {
  border-top: 1px solid white !important;
}

.btn-edit-response {
  text-align: left !important;
}
</style>
